import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'allAgentsCategory'
	| 'categoryBarLabel'
	| 'errorState'
	| 'starredCategory'
	| 'goBackLabel'
	| 'searchResults'
	| 'verifiedCategory'
	| 'yourAgentsCategory';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	allAgentsCategory: {
		id: 'studio-browse-kit.browse-agent.all-agents-category.ai-non-final',
		defaultMessage: 'All agents',
		description: 'Label for the category that displays all agents available to the current user.',
	},
	categoryBarLabel: {
		id: 'studio-browse-kit.browse-agent.category-bar-label.ai-non-final',
		defaultMessage: 'Agent categories',
		description:
			'Accessible label for the navigation controls that switch between groups of agents.',
	},
	errorState: {
		id: 'studio-browse-kit.browse-agent.error-state.ai-non-final',
		defaultMessage: 'We could not load agents. Try again later.',
		description: 'Error message shown in the browse modal when agent results cannot be loaded.',
	},
	starredCategory: {
		id: 'studio-browse-kit.browse-agent.starred-category.ai-non-final',
		defaultMessage: 'Starred',
		description: 'Label for the category tab that shows agents starred by the current user.',
	},
	goBackLabel: {
		id: 'studio-browse-kit.browse-agent.go-back-label.ai-non-final',
		defaultMessage: 'Go back',
		description: 'Label for returning to the agent list from a view opened within Browse Agent.',
	},
	searchResults: {
		id: 'studio-browse-kit.browse-agent.search-results.ai-non-final',
		defaultMessage: '{count, plural, one {# agent} other {# agents}}',
		description: 'Heading showing the number of agents matching the current search.',
	},
	verifiedCategory: {
		id: 'studio-browse-kit.browse-agent.verified-category.ai-non-final',
		defaultMessage: 'Verified',
		description: 'Label for the category that displays verified agents.',
	},
	yourAgentsCategory: {
		id: 'studio-browse-kit.browse-agent.your-agents-category.ai-non-final',
		defaultMessage: 'Your agents',
		description: 'Label for the category that displays agents created by the current user.',
	},
});
